module.exports = "./img/be430cee2d151a9a61c3c5025d7b7930.jpg";